import DocForm from './Provider';
import { useVisiblePreview, useSetVisiblePreview } from './hooks';

export default DocForm;
export { useVisiblePreview, useSetVisiblePreview };
